import instance from '../../api/instance'
const path = '/wv/nps'

export default {
    async info() {
        return await instance(window.config['application_host']).get(path + '/info.json')
    },
    async question() {
        return await instance(window.config['application_host']).get(path + '/question.json')
    },
    async submit(params) {
        return await instance(window.config['application_host']).post(path + '/submit', params)
    }
}
